import { Button, FileUploadOutlinedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { QuestionnaireExportConfirmationModal } from '../questionnaire-export-confirmation-modal';

interface QuestionnaireExportButtonProps {
  disabled?: boolean;
}

export default function QuestionnaireExportButton(props: Readonly<QuestionnaireExportButtonProps>) {
  const { disabled } = props;
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure();

  return (
    <>
      <Button startIcon={<FileUploadOutlinedIcon />} onClick={openModal} disabled={disabled}>
        Export
      </Button>
      <QuestionnaireExportConfirmationModal open={isModalOpen} onClose={closeModal} />
    </>
  );
}
